import React from 'react'
import welcome from "../../assets/CRMAssets/welcome@2x.png";
import styles from "./Style.module.css";

const Welcome = () => {
  return (
    <div className={styles.welcome}>
      <img src={welcome} alt="Welcome" className={styles.image} />
    </div>
  )
}

export default Welcome